import * as jsxRuntime from "C:\\Eidos!!!\\unitykista_students\\38-unity-kista-for-students\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment